import { Directive, ElementRef, Input } from '@angular/core';
import { FlyToCartService } from '../services/fly-to-cart.service';
import { BreakpointObserver } from '@angular/cdk/layout';
import { withLatestFrom } from 'rxjs/operators';

@Directive({
  selector: '[appFlyToCart]'
})
export class FlyToCartDirective {
  @Input('appFlyToCart') id: string
  @Input() cartSelector: string
  @Input() source: string
  private breakpoint = '(max-width: 991.98px)'

  constructor(private el: ElementRef,
              private flyToCartSvc: FlyToCartService,
              private breakpointObserver: BreakpointObserver) {
    flyToCartSvc.animatedSubject
      .pipe(
        withLatestFrom(
          this.breakpointObserver.observe([this.breakpoint]),
          (subject, state) => ({subject, state})
        )
      )
      .subscribe(data => {
        if (!data.state.matches)
          (data.subject.id === this.id) && (data.subject.source === this.source) ? this.animate() : ''
      } )
  }

  animate() {
    const cartElement = document.getElementById(this.cartSelector)
    if (cartElement) {
      let cartBoundingRect = cartElement.getBoundingClientRect()
      const itemBoundingRect = this.el.nativeElement.getBoundingClientRect()

      const itemClone = this.el.nativeElement.cloneNode()
      itemClone.classList.add('-cloned')

      this.el.nativeElement.appendChild(itemClone)
      cartBoundingRect = cartElement.getBoundingClientRect()
      itemClone.style.transform = `translate(${(cartBoundingRect.left - itemBoundingRect.left) - cartBoundingRect.width}px, ${(cartBoundingRect.top - itemBoundingRect.top - itemBoundingRect.height/2) + cartBoundingRect.height/2}px) scale(0)`
      setTimeout(_ => {
        cartElement.classList.add('-animated')
      }, 400)

      setTimeout(_ => {
        itemClone.parentNode.removeChild(itemClone)
        cartElement.classList.remove('-animated')
      }, 800)
    }

  }
}
